
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upcoming",
      function () {
        return require("private-next-pages/upcoming/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upcoming"])
      });
    }
  